import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'encodeuri'
})
export class EncodeuriPipe implements PipeTransform {

  transform(value: string): unknown {
    return encodeURIComponent(value);
  }

}
